import { z } from "zod";

export enum DictionaryLaboratorySchemaEnum {
	DictionaryLaboratory = "DictionaryLaboratory"
};

export const DictionaryLaboratorySchema = z.object({
	"@id": z.string(), // "/api/dictionary_laboratories/1"
	"@type": z.string(), // "DictionaryLaboratory"
	id: z.number(), // 1
	libelle: z.string(), // "Laboratory 1"
	aw_laboratory_id: z.string(), // "1"
}).describe(DictionaryLaboratorySchemaEnum.DictionaryLaboratory);

export type DictionaryLaboratory = z.infer<typeof DictionaryLaboratorySchema>;
